import { getRamonProgress, type RamonProgress } from "./progressApi";
import { registerCacheClear } from "@/lib/cache";

// One startup snapshot in memory only, owned by the authenticated account.
// Consumed once so later meal registrations always read fresh progress.
let warmup: { ownerId: string; expiresAt: number; promise: Promise<RamonProgress> } | null = null;
export function clearGemaProgressWarmup() { warmup = null; }
registerCacheClear(clearGemaProgressWarmup);
export function warmGemaProgress(ownerId: string) {
  if (warmup?.ownerId === ownerId && warmup.expiresAt > Date.now()) return;
  const entry = { ownerId, expiresAt: Date.now() + 15_000, promise: getRamonProgress() };
  warmup = entry;
  void entry.promise.catch(() => { if (warmup === entry) warmup = null; });
}
export function readInitialGemaProgress(ownerId?: string | null): Promise<RamonProgress> {
  const entry = warmup;
  warmup = null;
  if (ownerId && entry?.ownerId === ownerId && entry.expiresAt > Date.now()) return entry.promise;
  return getRamonProgress();
}
